type SetTutorFinishedParams = {
    isFinished: boolean
};

export class SetTutorFinished {
    public handle(_params: SetTutorFinishedParams): void {
    }
}
